import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { Observable } from 'rxjs';
import { stringify } from 'querystring';
import { CustomHttpParamsEncoder } from './settings/CustomHttpParamsEncoder';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService {

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {
  }

  public contactUs(email: string, city: string, school: string, extraInfo: string, direct_contact: boolean): Observable<any> {
    const params = new HttpParams({ encoder: new CustomHttpParamsEncoder() })
      .append('email', email)
      .append('municipality', city)
      .append('project', school)
      .append('description', extraInfo)
      .append('receive_emails', JSON.stringify(direct_contact));
    return this.http.post(this.config.getEndpoint('public/request_project'), null, { params });
  }
}
